import React, {useState, useEffect} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import {AddPreferredLocationModal} from "../components/modals/AddPreferredLocationModal";
import DynamicAlert from "../helpers/dynamicAlert";

export const PreferredStoreLocation = (preferredStoreDetails) => {
    const [show, setShow] = useState(false);

    const handleShow = () => setShow(true);
    let {oldStore, storeList} = preferredStoreDetails;
    const [newStore, setNewStore] = useState(null);
    const [alert, setAlert] = useState(null);

    const setTempAlert = (msg, type = "info") => {
        setAlert({
            id: Date.now(),
            msg,
            type
        });
    };

    const handleClose = (newStore) => {
        if (newStore) {
            setNewStore(newStore);
        }
        setShow(false);
    }

    preferredStoreDetails = {
        ...preferredStoreDetails, show, handleClose, storeList, setTempAlert
    }
    useEffect(() => {
        if (oldStore) {
            setNewStore(oldStore);
        }
    }, [oldStore]);

    return (
        <div className="mfa-body">
            <div className="mfa-container">
                <DynamicAlert alert={alert}/>
                <div className="p-1 py-2">
                    <div className="form-group">
                        <div className="text-center m-6-auto section-title">
                            <h4>Preferred Store Location</h4>
                        </div>
                        {oldStore ? <div>
                            <ul className="no-bullets">
                                <li>
                                    <h6>{newStore?.ecomName}</h6>

                                </li>
                                <li>{newStore?.address1 + " " + newStore?.ecomName}, {newStore?.postalCode}</li>

                                <li>
                                    {newStore?.voicePhone}
                                </li>
                            </ul>

                        </div> : ''
                        }
                        <button className="btn btn-outline-success" type="button" onClick={handleShow}
                                style={{width: "100%", borderRadius: "0"}}>
                            Change Store
                        </button>
                        <AddPreferredLocationModal {...preferredStoreDetails}/>
                    </div>
                </div>
                <AddPreferredLocationModal {...preferredStoreDetails}/>
            </div>
        </div>
    );
}


